// Sesión del panel de plataforma.
//
// Hermano de `src/auth.jsx` y deliberadamente SEPARADO de él. No comparten
// contexto, ni almacenamiento, ni cliente HTTP: mezclar los dos estados de
// sesión es exactamente cómo se filtra un token de un lado al otro.
//
// Diferencia visible con la sesión de cliente: aquí no se guarda el perfil
// en almacenamiento persistente. Al cerrar la pestaña, la sesión se acaba.
import { useState } from 'react';
import { apiPanel, guardarTokenPanel, leerTokenPanel } from './api';
import { ContextoPanel } from './contextoPanel';

const CLAVE_ADMIN = 'tego_panel_admin';

function leerAdminGuardado() {
  try {
    const crudo = sessionStorage.getItem(CLAVE_ADMIN);
    return crudo ? JSON.parse(crudo) : null;
  } catch {
    return null;
  }
}

export function ProveedorAuthPanel({ children }) {
  const [admin, setAdmin] = useState(() =>
    leerTokenPanel() ? leerAdminGuardado() : null,
  );

  async function iniciarSesion(email, password, codigo) {
    const r = await apiPanel.post('/auth/login', { email, password, codigo });
    guardarTokenPanel(r.access_token);
    const perfil = {
      email: r.email,
      nombre: r.nombre_completo,
      expira_minutos: r.expira_minutos,
    };
    sessionStorage.setItem(CLAVE_ADMIN, JSON.stringify(perfil));
    setAdmin(perfil);
  }

  function cerrarSesion() {
    guardarTokenPanel(null);
    sessionStorage.removeItem(CLAVE_ADMIN);
    setAdmin(null);
  }

  const valor = { admin, autenticado: !!admin, iniciarSesion, cerrarSesion };
  return <ContextoPanel.Provider value={valor}>{children}</ContextoPanel.Provider>;
}
